// var ua = window.navigator.userAgent;
// var trident = ua.indexOf('Trident/');
// var msie = ua.indexOf('MSIE ');

// if (msie > 0) {
//    ga('create', 'UA-46564202-39');
// } else if (trident > 0) {
//     ga('create', 'UA-46564202-39');
// } else {

function ready(callbackFunc) {
	if (document.readyState !== "loading") {
		// Document is already ready, call the callback directly
		callbackFunc();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener("DOMContentLoaded", callbackFunc);
	} else {
		// Old IE browsers
		document.attachEvent("onreadystatechange", function() {
			if (document.readyState === "complete") {
				callbackFunc();
			}
		});
	}
}

ready(function() {
	setTimeout(function() {
		const check_ga = async () => {
			return new Promise((resolve, reject) => {
				let gaAttempLoad = 0;

				let _isLoaded = () => {
					if (gaAttempLoad > 10) {
						reject("Timeout. Google analytics not injected!");
						return;
					}

					if (typeof ga === "function") {
						resolve(ga);
						return;
					} else {
						gaAttempLoad += 1;
						setTimeout(_isLoaded, 500);
					}
				};

				_isLoaded();
			});
		};

		check_ga()
			.then((result) => {
				console.log("LOADED", result);
				ga("create", "UA-46564202-39");
			})
			.catch(console.error);

		const gaHasLoaded = async () => {
			var gaLoaded = await check_ga();

			return [gaLoaded];
		};

		if (window.location.href.indexOf("vsl") > -1) {
			const get_url_parameter = (e) => {
				e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
				var n = new RegExp("[\\?&]" + e + "=([^&#]*)"),
					r = "";
				if (typeof t === "undefined") {
					r = n.exec(location.search);
				} else {
					r = n.exec(t);
				}
				return r == null ? "" : decodeURIComponent(r[1].replace(/\+/g, " "));
			};

			let utm_ad_url = get_url_parameter("utm_ad");

			let utm_ad_location = "";

			if (sessionStorage.getItem("utm_ad") !== null) {
				utm_ad_location = sessionStorage.getItem("utm_ad");
			} else if (utm_ad_url !== null) {
				utm_ad_location = utm_ad_url;
			}

			let pagename =
				window.location.href.split("?")[0] + "_utm_ad=" + utm_ad_location;

			const check_vimeo = () => {
				return new Promise((resolve, reject) => {
					let vimeoAttempLoad = 0;

					let _isLoaded = () => {
						if (vimeoAttempLoad > 10) {
							reject("Timeout. wistia is not injected!");
							return;
						}

						if ((containerLoaded = true)) {
							resolve();
							return;
						} else {
							vimeoAttempLoad += 1;
							let containerLoaded = document.getElementById("vimeoPlayer");
							setTimeout(_isLoaded, 500);
						}
					};

					_isLoaded();
				});
			};

			check_vimeo()
				.then((result) => {
					console.log("The Vimeo Player Embed promise worked");
				})
				.catch(console.error);

			//   const check_exitPopDisplay = () => {
			//   return new Promise((resolve, reject) => {
			//     let GAExitPopAttempt = 0;

			//     let _isLoaded = () => {

			//       if (sendGAExitPopDisplay === true) {
			//         resolve();
			//         return;
			//       } else {
			//         GAExitPopAttempt += 1;
			//         setTimeout(_isLoaded, 500);
			//       }
			//     };

			//     _isLoaded();
			//   });
			// };

			// check_exitPopDisplay().then(result => {
			//   console.log('The GA Exit Pop promise worked');
			// }).catch(console.error);

			const gaVimeo = async () => {
				var goog = await check_ga();
				var vim = await check_vimeo();

				return [goog, vim];
			};

			// const gaExitPop = async () => {
			//   var googexit = await check_ga();
			//   var exitpop = await check_exitPopDisplay();

			//   return [ googexit, exitpop];

			// }
			setTimeout(function() {
				gaVimeo()
					.then((result) => {
						console.log("Ga Vimeo loaded");
						let watchPercent = 0,
							iframeGA = document.getElementById("vimeoPlayer"),
							playerGA = new Vimeo.Player(iframeGA);
						playerGA.on("play", function() {
							ga("send", "event", {
								eventCategory: "Video",
								eventAction: "Pressed Play",
								eventLabel: "Video | Pressed Play | " + pagename,
							});

							playerGA.on("timeupdate", function(data) {
								if (data.percent > 0.1 && watchPercent == 0) {
									watchPercent = 1;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "10% Watched",
										eventLabel: "Video | 10% Watched | " + pagename,
									});
								}

								if (data.percent > 0.2 && watchPercent == 1) {
									watchPercent = 2;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "20% Watched",
										eventLabel: "Video | 20% Watched | " + pagename,
									});
								}

								if (data.percent >= 0.3 && watchPercent == 2) {
									watchPercent = 3;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "30% Watched",
										eventLabel: "Video | 30% Watched | " + pagename,
									});
								}

								if (data.percent >= 0.4 && watchPercent == 3) {
									watchPercent = 4;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "40% Watched",
										eventLabel: "Video | 40% Watched | " + pagename,
									});
								}

								if (data.percent >= 0.5 && watchPercent == 4) {
									watchPercent = 5;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "50% Watched",
										eventLabel: "Video | 50% Watched | " + pagename,
									});
								}

								if (data.percent >= 0.6 && watchPercent == 5) {
									watchPercent = 6;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "60% Watched",
										eventLabel: "Video | 60% Watched | " + pagename,
									});
								}

								if (data.percent >= 0.7 && watchPercent == 6) {
									watchPercent = 7;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "70% Watched",
										eventLabel: "Video | 70% Watched | " + pagename,
									});
								}
								if (data.percent >= 0.8 && watchPercent == 7) {
									watchPercent = 8;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "80% Watched",
										eventLabel: "Video | 80% Watched | " + pagename,
									});
								}
								if (data.percent >= 0.9 && watchPercent == 8) {
									watchPercent = 9;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "90% Watched",
										eventLabel: "Video | 90% Watched | " + pagename,
									});
								}
								if (data.percent >= 1.0 && watchPercent == 9) {
									watchPercent = 10;
									ga("send", "event", {
										eventCategory: "Video",
										eventAction: "100% Watched",
										eventLabel: "Video | 100% Watched | " + pagename,
									});
								}
							});
						});
					})
					.catch((error) => {
						console.log(error);
					});
			}, 1000);
			// gaHasLoaded().then( (result) => {
			//    console.log("Vsl append has loaded");
			//    var vslLink = $('.vslOrder').attr('href');

			//       if (vslLink.indexOf('?') > -1) {
			//         vslLink += '&view=vsl';
			//       } else {
			//         vslLink += '?view=vsl';
			//       }

			//       $('.vslOrder').attr('href', vslLink);
			//     }).catch( ( error ) => {
			//     console.log(error);
			//  } );

			gaHasLoaded()
				.then((result) => {
					ga("send", "event", {
						eventCategory: "Promo Page Visit",
						eventAction: "Visited | VSL Page",
						eventLabel: "VSL Page " + pagename,
					});
				})
				.catch((error) => {
					console.log(error);
				});

			//    gaHasLoaded().then( (result) => {

			//      $('#mobileTranscript').click(function () {
			//        ga('send', 'event', {
			//          'eventCategory': 'Promo Button Click',
			//          'eventAction': 'Promo Button Click | Mobile Only | Read Transcript',
			//          'eventLabel': 'Promo Button Click | Mobile Only | Read Transcript ' + pagename
			//        });
			//      });
			//  }).catch( ( error ) => {
			//    console.log(error);
			// } );

			//  gaExitPop().then( (result) => {

			//      if (sendGAExitPopDisplay === true) {
			//          ga('send', 'event', {
			//            'eventCategory': 'Exit Pop',
			//            'eventAction': 'Exit Pop Displayed',
			//            'eventLabel': 'Exit Pop Displayed | ' + pagename
			//          });
			//          console.log('GA event fired');
			//      } else {
			//          console.log('GA function is the problem');
			//      }

			//  }).catch( ( error ) => {
			//    console.log(error);
			// } );

			//  gaHasLoaded().then( (result) => {

			//      $('.GAexitclose').click(function () {
			//        ga('send', 'event', {
			//          'eventCategory': 'Exit Pop',
			//          'eventAction': 'Exit Pop Button Click | Close Button',
			//          'eventLabel': 'Exit Pop Button Click | Close Button ' + pagename
			//        });
			//      });
			//      $('.GAexitvideolink').click(function(){
			//        ga('send', 'event', {
			//          'eventCategory' : 'Exit Pop',
			//          'eventAction' : 'Exit Pop Button Click | Watch Video Text Link',
			//          'eventLabel' : 'Exit Pop Button Click | Watch Video Text Link | '+ pagename
			//        });
			//      });
			//      $('.GAexittranslink').click(function(){
			//        ga('send', 'event', {
			//          'eventCategory' : 'Exit Pop',
			//          'eventAction' : 'Exit Pop Button Click | Read Transcript Text Link',
			//          'eventLabel' : 'Exit Pop Button Click | Read Transcript Text Link | '+ pagename
			//        });
			//      });
			//      $('.GAexitvideobutton').click(function(){
			//        ga('send', 'event', {
			//          'eventCategory' : 'Exit Pop',
			//          'eventAction' : 'Exit Pop Button Click | Watch Video Button',
			//          'eventLabel' : 'Exit Pop Button Click | Watch Video Button | '+ pagename
			//        });
			//      });
			//      $('.GAexittransbutton').click(function(){
			//        ga('send', 'event', {
			//          'eventCategory' : 'Exit Pop',
			//          'eventAction' : 'Exit Pop Button Click | Read Transcript Button',
			//          'eventLabel' : 'Exit Pop Button Click | Read Transcript Button | '+ pagename
			//        });
			//      });
			//    }).catch( ( error ) => {
			//    console.log(error);
			// } );
		} else if (window.location.href.indexOf("transcript") > -1) {
			const get_url_parameter = (e) => {
				e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
				var n = new RegExp("[\\?&]" + e + "=([^&#]*)"),
					r = "";
				if (typeof t === "undefined") {
					r = n.exec(location.search);
				} else {
					r = n.exec(t);
				}
				return r == null ? "" : decodeURIComponent(r[1].replace(/\+/g, " "));
			};

			let utm_ad_url = get_url_parameter("utm_ad");

			let utm_ad_location = "";

			if (sessionStorage.getItem("utm_ad") !== null) {
				utm_ad_location = sessionStorage.getItem("utm_ad");
			} else if (utm_ad_url !== null) {
				utm_ad_location = utm_ad_url;
			}

			let pagename =
				window.location.href.split("?")[0] + "_utm_ad=" + utm_ad_location;

			//add parameter when click on HTML Page Order Button (.htmlOrder)

			// gaHasLoaded().then( (result) => {
			//       // var htmlLink = $('.htmlOrder').attr('href');

			//       // if (htmlLink.indexOf('?') > -1) {
			//       //   htmlLink += '&view=html';
			//       // } else {
			//       //   htmlLink += '?view=html';
			//       // }

			//       // $('.htmlOrder').attr('href', htmlLink);
			// }).catch( ( error ) => {
			//     console.log(error);
			//  } );
			// Event Functions
			gaHasLoaded()
				.then((result) => {
					ga("send", "event", {
						eventCategory: "Promo Page Visit",
						eventAction: "Visited | HTML Page",
						eventLabel: "HTML Page " + pagename,
					});
				})
				.catch((error) => {
					console.log(error);
				});

			gaHasLoaded()
				.then((result) => {
					setTimeout(function() {
						var docHeight = $(document).height(),
							docQuarter = docHeight / 10,
							scrolled = 0;
						$(window).scroll(function() {
							var curScroll = $(window).scrollTop() + $(window).height();

							if (curScroll >= docQuarter && scrolled == 0) {
								scrolled = 1;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "10%",
									eventLabel: "Scroll Reach | 10% | " + pagename,
								});
							} else if (curScroll >= docQuarter * 2 && scrolled == 1) {
								scrolled = 2;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "20%",
									eventLabel: "Scroll Reach | 20% | " + pagename,
								});
							} else if (curScroll >= docQuarter * 3 && scrolled == 2) {
								scrolled = 3;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "30%",
									eventLabel: "Scroll Reach | 30% | " + pagename,
								});
							} else if (curScroll >= docQuarter * 4 && scrolled == 3) {
								scrolled = 4;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "40%",
									eventLabel: "Scroll Reach | 40% | " + pagename,
								});
							} else if (curScroll >= docQuarter * 5 && scrolled == 4) {
								scrolled = 5;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "50%",
									eventLabel: "Scroll Reach | 50% | " + pagename,
								});
							} else if (curScroll >= docQuarter * 6 && scrolled == 5) {
								scrolled = 6;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "60%",
									eventLabel: "Scroll Reach | 60% | " + pagename,
								});
							} else if (curScroll >= docQuarter * 7 && scrolled == 6) {
								scrolled = 7;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "70%",
									eventLabel: "Scroll Reach | 70% | " + pagename,
								});
							} else if (curScroll >= docQuarter * 8 && scrolled == 7) {
								scrolled = 8;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "80%",
									eventLabel: "Scroll Reach | 80% | " + pagename,
								});
							} else if (curScroll >= docQuarter * 9 && scrolled == 8) {
								scrolled = 9;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "90%",
									eventLabel: "Scroll Reach | 90% | " + pagename,
								});
							} else if (curScroll >= docQuarter * 10 && scrolled == 9) {
								scrolled = 10;
								ga("send", "event", {
									eventCategory: "Scroll Reach",
									eventAction: "100%",
									eventLabel: "Scroll Reach | 100% | " + pagename,
								});
							}
						});
					}, 3000);
				})
				.catch((error) => {
					console.log(error);
				});
		} else if (window.location.href.indexOf("order") > -1) {
			setTimeout(function() {
				const get_url_parameter = (e) => {
					e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
					var n = new RegExp("[\\?&]" + e + "=([^&#]*)"),
						r = "";
					if (typeof t === "undefined") {
						r = n.exec(location.search);
					} else {
						r = n.exec(t);
					}
					return r == null ? "" : decodeURIComponent(r[1].replace(/\+/g, " "));
				};

				let utm_ad_url = get_url_parameter("utm_ad");

				let utm_ad_location = "";

				if (sessionStorage.getItem("utm_ad") !== null) {
					utm_ad_location = sessionStorage.getItem("utm_ad");
				}

				let pagename =
					window.location.href.split("?")[0] + "_utm_ad=" + utm_ad_location;

				gaHasLoaded()
					.then((result) => {
						ga("send", "event", {
							eventCategory: "Promo Page Visit",
							eventAction: "Visited | Order Page",
							eventLabel: "Order Page " + pagename,
						});
					})
					.catch((error) => {
						console.log(error);
					});
			}, 4000);
		} else if (window.location.href.indexOf("offer") > -1) {
			setTimeout(function() {
				const get_url_parameter = (e) => {
					e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
					var n = new RegExp("[\\?&]" + e + "=([^&#]*)"),
						r = "";
					if (typeof t === "undefined") {
						r = n.exec(location.search);
					} else {
						r = n.exec(t);
					}
					return r == null ? "" : decodeURIComponent(r[1].replace(/\+/g, " "));
				};

				let utm_ad_url = get_url_parameter("utm_ad");

				let utm_ad_location = "";

				if (sessionStorage.getItem("utm_ad") !== null) {
					utm_ad_location = sessionStorage.getItem("utm_ad");
				}

				let pagename =
					window.location.href.split("?")[0] + "_utm_ad=" + utm_ad_location;

				gaHasLoaded()
					.then((result) => {
						ga("send", "event", {
							eventCategory: "Promo Page Visit",
							eventAction: "Visited | Upsell Page",
							eventLabel: "Upsell Page " + pagename,
						});
					})
					.catch((error) => {
						console.log(error);
					});
			}, 4000);
		}

		// // gaHasLoaded().then( (result) => {

		// //       $('#addToCart').click(function () {
		// //         ga('send', 'event', {
		// //           'eventCategory': 'Promo Button Click',
		// //           'eventAction': 'Promo Button Click | Add To Cart',
		// //           'eventLabel': 'Promo Button Click | Add To Cart ' + pagename
		// //         });
		// //       });
		// //  }).catch( ( error ) => {
		// //     console.log(error);
		// //  } );

		// // gaHasLoaded().then( (result) => {

		// //       $('#productLabel').click(function () {
		// //         ga('send', 'event', {
		// //           'eventCategory': 'Promo Button Click',
		// //           'eventAction': 'Promo Button Click | Product Label',
		// //           'eventLabel': 'Promo Button Click | Product Label ' + pagename
		// //         });
		// //       });
		// //   }).catch( ( error ) => {
		// //     console.log(error);
		// //  } );
	});
}, 1000);
